module.exports = __webpack_public_path__ + "img/yemen.7d308e44.svg";